import React, { useEffect, useState } from 'react';
import type { FC, PropsWithChildren } from 'react';
import type { Version } from '../../contexts/VersionsContext';
import { VersionsContext } from '../../contexts/VersionsContext';

export const VersionListProvider: FC<PropsWithChildren> = ({ children }) => {
  const [versions, setVersions] = useState<Version[]>([]);

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/history.json`)
      .then(async (res) => res.json())
      .then((versions: Version[]) => {
        setVersions(versions);
      })
      .catch((error) => {
        console.error(error);
        setVersions([]);
      });
  }, []);

  return (
    <VersionsContext.Provider value={{ versions }}>
      {children}
    </VersionsContext.Provider>
  );
};
